var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{class:{ 'transparent-loader': _vm.fullScreen === true }},[_c('div',{staticClass:"loader",class:{ 'loader--sm': _vm.size === 'small' }})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }